import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import UseLoginStore from '../../stores/LoginStore';
import {removeStorageItem, StorageKeys} from '../../stores/StorageHelper';

export default function Logout() {
  const navigate = useNavigate();

  const {logout} = UseLoginStore();

  useEffect(() => {
    (async () => {
      removeStorageItem(StorageKeys.AUTH_JWT_ACCESS_TOKEN);
      removeStorageItem(StorageKeys.ACTIVE_ACCOUNT_ID);
      await logout();
      navigate('/auth/login');
    })();
  }, []);

  return (
    <div className="mb-16 mt-16 flex h-full w-full flex-col items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">CashFlo Payment Dashboard</h4>
      <h6>Internal use only</h6>

      <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
        Logging out...
      </div>
    </div>
  );
}
